module.exports = __webpack_public_path__ + "media/images/icon__unlocked-b082a46f08750bb62b1af7a010b24932.png";